module.exports = __webpack_public_path__ + "img/CAR_WASH_1.6b8fcc83.jpg";